// extracted by mini-css-extract-plugin
module.exports = {"iconParagraph":"iconParagraph_iconParagraph__2u910","text":"iconParagraph_text__1Yj6n","pic":"iconParagraph_pic__2tVur"};